<div class="thumbnail-characters small">
  <span>{{thumbnailLetter}}</span>
</div>
